import React from 'react';
import AMV2AssetSelector from './AMV2AssetSelector';
import openAMV2ChooseAssetModal from './openAMV2ChooseAssetModal';
import openAMV2MoveTargetModal from './openAMV2MoveTargetModal';
import openAMV2UploadTargetModal from './openAMV2UploadTargetModal';
import { AMV2AssetPickerArgs, CbModalProps } from './utils/types';

export const AMV2AssetPicker: React.FC<AMV2AssetPickerArgs & CbModalProps> = (props) => {
  return (
    <AMV2AssetSelector
      {...props}
    />
  );
};

export { openAMV2ChooseAssetModal, openAMV2MoveTargetModal, openAMV2UploadTargetModal };